import React from "react";
import "./style.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import coin1 from "../../../../../../../Assets/Images/coin1.png";
import coin2 from "../../../../../../../Assets/Images/coin2.png";
import coin3 from "../../../../../../../Assets/Images/coin3.png";
import coin4 from "../../../../../../../Assets/Images/coin4.png";
import coin5 from "../../../../../../../Assets/Images/coin5.png";
import coin6 from "../../../../../../../Assets/Images/coin6.png";

const Guidelines = ({ data }) => {

  const iconList = {
    "EX": coin1,
    "M": coin2,
    "I": coin3,
    "B": coin4,
    "A": coin5,
    "NA": coin6
  }
  return (
    <div className="guidelines">
      {data?.activityDetails?.description?.guidelines?.length > 0 &&
        <div class="guidelines-sec container-fluid box-outer-sec">
          <div class="guidelines-heading sec-heading">
            <h5 className="mb-3">Guidelines</h5>
          </div>
          <div class="guidelines-content py-3">
            <div class="grades-icons py-3 col-md-12 col-sm-11 mx-auto">
              <nav class="activity-guidlines">
                <Tabs defaultActiveKey={data?.activityDetails?.description?.guidelines?.[0]?.grade} id="fill-tab-example" className="mb-3" fill>
                  {data?.activityDetails?.description?.guidelines?.map(item => <Tab eventKey={item?.grade} title={<img src={iconList[item?.grade]} alt="coin1" />}><p>{item?.description}</p></Tab>)}
                </Tabs>
              </nav>
            </div>
          </div>
        </div>
      }
    </div>
  );
};

export default Guidelines;
